module.exports = "<canvas [id]=\"id\"></canvas>\r\n"